var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{attrs:{"id":"orders"}},[_c('b-header'),_c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"cal"},domProps:{"innerHTML":_vm._s(_vm.calendar)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }